import { render, staticRenderFns } from "./ChangeForeignCompany.vue?vue&type=template&id=0a93e012&scoped=true"
import script from "./ChangeForeignCompany.vue?vue&type=script&lang=js"
export * from "./ChangeForeignCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a93e012",
  null
  
)

export default component.exports